// frontend/source/portal/components/AdminArtworkDisplay.js
import React, { useState } from "react";
import ImagePicker from "./ImagePicker";
import "./AdminArtworkDisplay.css";

const AdminArtworkDisplay = ({ artwork, onUpdate }) => {
  const [showImagePicker, setShowImagePicker] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleImageSelect = async (imageUrl) => {
    try {
      setIsSaving(true);
      await onUpdate({ image: imageUrl });
    } catch (err) {
      console.error("Failed to update image:", err);
    } finally {
      setIsSaving(false);
      setShowImagePicker(false);
    }
  };

  return (
    <div className="admin-artwork-display">
      <div className="admin-artwork-display-container">
        <img
          src={artwork.image}
          alt={artwork.title}
          className="admin-artwork-display-image"
        />
        <button
          onClick={() => setShowImagePicker(true)}
          className="admin-artwork-display-change-btn"
          title="Change artwork image"
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : "📷 Change Image"}
        </button>
      </div>

      {showImagePicker && (
        <ImagePicker
          currentImage={artwork.image}
          onImageSelect={handleImageSelect}
          onClose={() => setShowImagePicker(false)}
        />
      )}
    </div>
  );
};

export default AdminArtworkDisplay;
